import { render, staticRenderFns } from "./RelatedProducts.sync.vue?vue&type=template&id=5cea513c&scoped=true&"
import script from "./RelatedProducts.sync.vue?vue&type=script&lang=js&"
export * from "./RelatedProducts.sync.vue?vue&type=script&lang=js&"
import style0 from "./RelatedProducts.sync.vue?vue&type=style&index=0&id=5cea513c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cea513c",
  null
  
)

export default component.exports